// Ugly but necessary compromise to provide stylesheets for external deps (why
// doesn't the production build use its *own* stylesheet?) while sticking with
// css modules for application code. Am hard-coding everything b/c webpack wants
// dependency requests to be known at compilation time. The prefix is taken from
// discussion at: https://github.com/css-modules/css-modules/issues/164
import '!style-loader!css-loader!draft-js/dist/Draft.css'
import '!style-loader!css-loader!draft-js-image-plugin/lib/plugin.css'
import '!style-loader!css-loader!draft-js-alignment-plugin/lib/plugin.css'
import '!style-loader!css-loader!draft-js-anchor-plugin/lib/plugin.css'
import '!style-loader!css-loader!draft-js-inline-toolbar-plugin/lib/plugin.css'
import '!style-loader!css-loader!./rich-text-editor.css'



// WEBPACK FOOTER //
// ./src/styles/rich-text-editor.js